import {createAction} from '@reduxjs/toolkit';

export const selectResult = createAction('GEOCODER_SELECT_RESULT');
